/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { CalculationSettingsUploadResult } from './CalculationSettingsUploadResult';
import {
    CalculationSettingsUploadResultFromJSON,
    CalculationSettingsUploadResultFromJSONTyped,
    CalculationSettingsUploadResultToJSON,
    CalculationSettingsUploadResultToJSONTyped,
} from './CalculationSettingsUploadResult';
import type { FileProcessResultResponse } from './FileProcessResultResponse';
import {
    FileProcessResultResponseFromJSON,
    FileProcessResultResponseFromJSONTyped,
    FileProcessResultResponseToJSON,
    FileProcessResultResponseToJSONTyped,
} from './FileProcessResultResponse';

/**
 * 
 * @export
 * @interface CalculationSettingsFileProcessResultResponse
 */
export interface CalculationSettingsFileProcessResultResponse {
    /**
     * 
     * @type {FileProcessResultResponse}
     * @memberof CalculationSettingsFileProcessResultResponse
     */
    fileProcessResult: FileProcessResultResponse;
    /**
     * 
     * @type {CalculationSettingsUploadResult}
     * @memberof CalculationSettingsFileProcessResultResponse
     */
    uploadResult?: CalculationSettingsUploadResult;
}

/**
 * Check if a given object implements the CalculationSettingsFileProcessResultResponse interface.
 */
export function instanceOfCalculationSettingsFileProcessResultResponse(value: object): value is CalculationSettingsFileProcessResultResponse {
    if (!('fileProcessResult' in value) || value['fileProcessResult'] === undefined) return false;
    return true;
}

export function CalculationSettingsFileProcessResultResponseFromJSON(json: any): CalculationSettingsFileProcessResultResponse {
    return CalculationSettingsFileProcessResultResponseFromJSONTyped(json, false);
}

export function CalculationSettingsFileProcessResultResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculationSettingsFileProcessResultResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'fileProcessResult': FileProcessResultResponseFromJSON(json['fileProcessResult']),
        'uploadResult': json['uploadResult'] == null ? undefined : CalculationSettingsUploadResultFromJSON(json['uploadResult']),
    };
}

export function CalculationSettingsFileProcessResultResponseToJSON(json: any): CalculationSettingsFileProcessResultResponse {
    return CalculationSettingsFileProcessResultResponseToJSONTyped(json, false);
}

export function CalculationSettingsFileProcessResultResponseToJSONTyped(value?: CalculationSettingsFileProcessResultResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileProcessResult': FileProcessResultResponseToJSON(value['fileProcessResult']),
        'uploadResult': CalculationSettingsUploadResultToJSON(value['uploadResult']),
    };
}

